var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading && _vm.variants.length)?_c('div',[_vm._l((_vm.data),function(order){return _c('PrintOrder',{key:order.id,attrs:{"order":order}})}),_c('div',{staticClass:"pagebreak"}),(_vm.$route.query.print_table)?_c('OrdersStatisticsTable',{attrs:{"stats":_vm.stats}}):_vm._e()],2):_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }